import { pdfToText, parseCsv, parseStatementText } from "@/lib/statementParser";

export const TSP_LOGIN_URL = "https://www.tsp.gov/login/";
const DAY = 864e5;
const ALLOC_KEYS = ["G", "F", "C", "S", "I", "L"];

export const tspHoldings = (dash) => (dash?.holdings || []).filter((h) => h.account === "tsp");

export function lastSharesUpdate(dash) {
  const times = [dash?.meta?.shares_updated_at, ...tspHoldings(dash).map((h) => h.updated_at)].filter(Boolean).map((t) => new Date(t).getTime());
  return times.length ? new Date(Math.max(...times)) : null;
}

export const daysSince = (d, now = Date.now()) => (d ? Math.floor((now - d.getTime()) / DAY) : null);
export const isStale = (dash) => { const d = daysSince(lastSharesUpdate(dash)); return d === null || d > 30; };

export function allocationFromValues(values) {
  const sums = Object.fromEntries(ALLOC_KEYS.map((k) => [k, 0]));
  Object.entries(values).forEach(([f, v]) => { sums[f.startsWith("L") ? "L" : f] += Number(v) || 0; });
  const total = Object.values(sums).reduce((a, b) => a + b, 0);
  if (!total) return null;
  const pct = Object.fromEntries(ALLOC_KEYS.map((k) => [k, Math.round((sums[k] / total) * 100)]));
  const top = ALLOC_KEYS.reduce((a, b) => (pct[a] >= pct[b] ? a : b));
  pct[top] += 100 - Object.values(pct).reduce((a, b) => a + b, 0);
  return pct;
}

export async function readStatement(file, prices) {
  const isPdf = file.name.toLowerCase().endsWith(".pdf");
  const snaps = isPdf ? parseStatementText(await pdfToText(file)) : parseCsv(await file.text(), "shares");
  const s = snaps[snaps.length - 1];
  if (!s) return null;
  const shares = { ...s.holdings };
  Object.entries(s.balances || {}).forEach(([f, b]) => { if (shares[f] == null && prices[f]) shares[f] = Math.round((b / prices[f]) * 10000) / 10000; });
  const values = Object.keys(s.balances || {}).length ? s.balances : Object.fromEntries(Object.entries(shares).map(([f, u]) => [f, u * (prices[f] || 0)]));
  return { shares, allocation: allocationFromValues(values) };
}
